

import React from 'react'

const EmptyCart = () => {
  return (
    <div style={{ width:"60%" ,margin:"auto" ,textAlign:"center" , marginTop:"5%"   }}  >
           
        <img style={{ margin:"auto" , width:"40%" ,borderRadius:"20px"}} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7rwE7FxCMNVoJv9v6fNZU5PPrfy8CniN_aA&usqp=CA" alt="" />  
        <h2 textAlign="center" style={{color:"gray"}}  >Opps Cart is Empty 🥺</h2>


    </div>
  )
}

export default EmptyCart